// extracted by mini-css-extract-plugin
export default {"optimizationFilters":"optimization-filters_optimizationFilters__5N5z5"};